module.exports = __webpack_public_path__ + "static/img/version4.6e83f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/version4.png
// module id = TfiF
// module chunks = 1